module.exports = __webpack_public_path__ + "img/banner3.260c41e1.png";